import { render } from "./OficinaShow.vue?vue&type=template&id=1de1ce8e"
import script from "./OficinaShow.vue?vue&type=script&lang=js"
export * from "./OficinaShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__